

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import { MenuItem } from '@/models/menu.interface';

@Component
export default class SideBar extends Vue {
  @Action('activeMenuItemAction') public activeMenuItemAction!: (label: string) => void;
  @Getter public sideBarOpened!: boolean;
  @Getter public menuItems!: MenuItem[];

  public goToMenuLink(menu: MenuItem): void {
    this.$router.push(menu.url);
    this.activeMenuItemAction(menu.label);
  }
}
